import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mobile-filter",
  "use": "icon-mobile-filter-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-mobile-filter\">\n    <path d=\"M9.3 15.2v-9c0-.2.1-.4.2-.5l3.2-4.1H3.3l3.2 4c.1.2.2.4.2.5v5.334l-1.6.766V6.4L1 1.3 1.6 0h12.7l.6 1.3-4.1 5.1V16\" fill=\"#000018\" fill-rule=\"nonzero\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol